
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'testString': 'test',
	'visualizationSlideoutTitle': 'Visualizzazioni',
	'listSeparator': ',',
	'pointSeparator': ':',
	'minValuePlaceholder': 'Immettere un numero.',
	'maxValuePlaceholder': 'Immettere un numero.',
	'customRangeErrorMessage': 'Il valore deve essere un numero',
	'propFillColor': 'Colore riempimento',
	'propBorderColor': 'Colore bordo',
	'propColorPalette': 'Tavolozza colori corrente',
	'propColorPaletteChangeLabel': 'Modifica tavolozza colori',
	'propNewColorPaletteLabel': 'Crea una tavolozza  colori personalizzata',
	'propNewHeatPaletteLabel': 'Crea una tavolozza heat personalizzata',
	'propDonutRadius': 'Raggio grafico ad anello',
	'showTitleLabel': 'Mostra titolo',
	'titleTypeLabel': 'Tipo di titolo',
	'smartTitleLabel': 'Titolo Smart',
	'customTitleLabel': 'Titolo personalizzato',
	'noTitleLabel': 'Nessun titolo',
	'propHeatScalePalette': 'Tavolozza di calore corrente',
	'propHeatPaletteChangeLabel': 'Modifica tavolozza di calore',
	'propMaintainAxisScales': 'Conserva scala asse',
	'propLineAndSymbolColor': 'Colore linea e simbolo',
	'propLineAndSymbolPalette': 'Tavolozza colore di linea e simbolo',
	'propElementColor': 'Colore elemento',
	'propColumnColor': 'Colore colonna',
	'propColumnPalette': 'Tavolozza dei colori della colonna',
	'propColumnHeatPalette': 'Tavolozza di calore colonna',
	'propBarColor': 'Colore barra',
	'propGoalColor': 'Colore di destinazione',
	'propToColor': 'Colore A',
	'propFromColor': 'Colore Da',
	'propNumberValidationErrorMessageId': 'Immettere un numero.',
	'fontSizeAuto': 'Automatico',
	'propAutoBinCount': 'Numero di gruppi',
	'propAutoBinToggle': 'Raggruppamento automatico',
	'tabName_general': 'Generale',
	'tabName_visDetails': 'Dettagli',
	'tabName_animation': 'Animazione',
	'tabName_mediaDetails': 'Dettagli supporti',
	'tabName_webDetails': 'Dettagli pagina Web',
	'tabName_imageDetails': 'Dettagli immagine',
	'tabName_visualization': 'Visualizzazione',
	'tabName_text': 'Testo',
	'sectionName_colorsAndThemes': 'Colore e temi',
	'sectionName_appearance': 'Aspetto',
	'sectionName_general': 'Generale',
	'sectionName_colorPalette': 'Colore',
	'sectionName_axis': 'Asse',
	'sectionName_axis_label': 'Asse',
	'sectionName_legend': 'Legenda',
	'sectionName_chart': 'Grafico',
	'sectionName_regionLayer': 'Livello delle regioni',
	'sectionName_pointLayer': 'Livello dei punti',
	'sectionName_latLongLayer': 'Livello latitudine/longitudine',
	'sectionName_pathLayer': 'Livello percorso',
	'sectionName_xAxis': 'Asse X',
	'sectionName_yAxis': 'Asse Y',
	'sectionName_xAxis_title': 'Titolo asse X',
	'sectionName_yAxis_title': 'Titolo asse Y',
	'sectionName_xAxis_label': 'Etichetta dell\'asse X',
	'sectionName_yAxis_label': 'Etichetta dell\'asse Y',
	'sectionName_column_yAxis': 'Asse Y colonna',
	'sectionName_column_yAxis_label': 'Etichetta asse Y colonna',
	'sectionName_column_yAxis_title': 'Titolo asse Y colonna',
	'sectionName_line_yAxis': 'Asse Y linea',
	'sectionName_line_yAxis_label': 'Etichetta asse Y di linea',
	'sectionName_line_yAxis_title': 'Titolo asse Y della linea',
	'sectionName_title': 'Titolo',
	'sectionName_dataValueLabels': 'Etichette valore dati',
	'sectionName_style': 'Stile',
	'propTransparencyDescription': 'Rendere l\'oggetto più o meno trasparente Immettere un valore compreso tra 0 e 100',
	'smart_annotation_unauthorized': 'Annotazioni: accesso non autorizzato',
	'smart_annotation_method': 'Annotazioni: metodo non consentito',
	'smart_annotation_media': 'Annotazioni: tipo di supporto non consentito',
	'smart_annotation_input': 'Annotazioni: input non valido',
	'smart_annotation_internal': 'Annotazioni: errore di sistema interno',
	'smart_annotation_generic_error': 'Annotazioni: errore del servizio',
	'smart_annotation_dialog_title': 'Insight',
	'smart_annotation_Show_Insights': 'Mostra insight',
	'smart_annotation_Relationship': 'La relazione è',
	'forecast_enter_number': 'Inserire un numero compreso tra ',
	'and': ' e ',
	'smart_errors': 'Errori di annotazione:',
	'smart_warnings': 'Avvertenze annotazione:',
	'smart_annotation_insight_icon_title': 'Insight',
	'smart_annotations_toggle_on': 'Attiva insight',
	'smart_annotations_toggle_off': 'Disattiva insight',
	'smart_annotation_toggle_on': 'Attiva',
	'smart_annotation_toggle_off': 'Disattiva',
	'smart_annotation_insight_unavailable': 'Insight attualmente non disponibili',
	'smart_annotation_insight_topBottom_percent_unsupported': 'Non sono disponibili insight quando viene applicato un filtro % superiore o inferiore.',
	'smart_annotation_forecast_topBottom_percent_unsupported': 'Non sono disponibili previsioni quando viene applicato un filtro % superiore o inferiore.',
	'smart_annotation_insight_topBottom_nested_dataItem_unsupported': 'Gli insight non sono disponibili quando viene applicato un filtro superiore o inferiore ed esiste più di una colonna nel campo',
	'smart_annotation_forecast_topBottom_nested_dataItem_unsupported': 'La previsione non è disponibile quando viene applicato un filtro superiore o inferiore e c\'è più di una colonna nel campo',
	'forecast_title': 'Previsione',
	'forecast_show': 'Mostra previsione',
	'forecast_toggle_on': 'Attiva previsione',
	'forecast_toggle_off': 'Disattiva previsione',
	'statDetailsPerspectiveTitle': 'Analisi',
	'emptyStatDetailsPanel': 'Non è disponibile nessuna ulteriore analisi per la visualizzazione corrente.',
	'predict_errors': 'Errori di analisi',
	'predict_warnings': 'Avvertenze di analisi',
	'fpd_invalid_data_source': 'Questa origine dati non ha un modulo smarts associato',
	'fpd_network_issue': 'Si è verificato un problema durante l\'esecuzione dell\'analisi su questa origine dati',
	'fpd_data_source_category': 'Modulo Smarts mancante',
	'fpd_response_errors': 'Errori driver consigliato',
	'fpd_response_warnings': 'Avvertenze driver consigliato',
	'catalyst_service_bad_request': 'Richiesta non valida',
	'catalyst_service_unkown_Id': 'Individuato ID richiesta sconosciuto',
	'catalyst_service_internal_server_error': 'Errore server interno',
	'catalyst_service_generic_error': 'Errore server Catalyst',
	'catalyst_service_error': 'Questo servizio non è attualmente disponibile',
	'propLegendPosition': 'Posizione legenda',
	'propLeft': 'Sinistra',
	'propRight': 'Destra',
	'propTop': 'In alto',
	'propBottom': 'In basso',
	'propNone': 'Nessuna',
	'propLegendDisplay': 'Visualizza legenda',
	'targetThicknessPlaceHolder': '%{min} in %{max}',
	'targetThicknessErrorMsg': 'Inserire un numero intero compreso tra %{min} e %{max}.',
	'possibleKeyDriver_DialogDriversLabelBegin': 'Driver (',
	'possibleKeyDriver_DialogDriversLabelEnd': 'selezionati)',
	'possibleKeyDriver_DialogDriversLabelDivider': '/',
	'possibleKeyDriver_DialogDriversResetToDefaultsLabel': 'Reimposta valori predefiniti',
	'possibelKeyDriver_AddNewDrivers': 'Aggiungi ulteriori driver',
	'possibleKeyDrivers_NonRecommended_Placeholder': 'Ricerca per aggiungere altri driver',
	'possibleKeyDrivers_MaxPossibleReached': 'Annullare la selezione di alcuni driver per aggiungerne o selezionarne altri',
	'possibleKeyDrivers_Recommended': 'Consigliato',
	'visRecommendedTypes': 'Tipi di visualizzazione consigliati',
	'visRecommender_smartsfailure': 'le indicazioni di visualizzazione non sono attualmente disponibili',
	'visMore': 'Altro...',
	'visMoreTooltip': 'Altre visualizzazioni',
	'visOtherTypes': 'Altri tipi di visualizzazione',
	'visChange': 'Visualizzazione modifica',
	'automaticTypeCaption': 'Automatico',
	'propVisType': 'Tipi di visualizzazione',
	'dlg_loading': 'Caricamento in corso...',
	'snippetListChartCaption': 'Elenco frammenti',
	'convoClusterChartCaption': 'Cluster di conversazione',
	'areaChartCaption': 'Area',
	'barChartCaption': 'Barra',
	'columnChartCaption': 'Colonna',
	'stackedbarChartCaption': 'Barra in pila',
	'stackedcolumnChartCaption': 'Colonna in pila',
	'bubbleChartCaption': 'Bolle',
	'marimekkoChartCaption': 'Marimekko',
	'cometChartCaption': 'Analisi driver',
	'scatterChartCaption': 'Dispersione',
	'lineChartCaption': 'Riga',
	'pointChartCaption': 'Punti',
	'heatChartCaption': 'Mappa calore',
	'bulletChartCaption': 'Punto elenco',
	'waterfallChartCaption': 'Cascata',
	'radarChartCaption': 'Radar',
	'boxplotChartCaption': 'Box a dispersione',
	'pieChartCaption': 'Torta',
	'mapChartCaption': 'Mappa',
	'radialBarChartCaption': 'Radiale',
	'compositeChartCaption': 'Linea e colonna',
	'wordCloudChartCaption': 'Word cloud',
	'networkChartCaption': 'Rete',
	'relationshipNetworkChartCaption': 'Rete di relazione',
	'treemapChartCaption': 'Mappa struttura ad albero',
	'packedBubbleChartCaption': 'Diagramma a bolle',
	'hierarcicalPackedBubbleChartCaption': 'Bolla gerarchia',
	'spiralChartCaption': 'Spirale',
	'decisionTreeChartCaption': 'Struttura ad albero delle decisioni',
	'legacyMapChartCaption': 'Mappa esistente',
	'sunburstChartCaption': 'A raggiera',
	'visUsageComparison': 'Confronto',
	'visUsageRelationships': 'Relazioni',
	'visUsageTrend': 'Tendenza',
	'visUsagePartsToWhole': 'Parti rispetto all\'intero',
	'visUsageGeospatial': 'Geospaziale',
	'visUsageAdvanced': 'Analisi avanzate',
	'visUsageTablesAndSummary': 'Tabelle e riepilogo',
	'visUsageSocialInsights': 'Informazioni social',
	'visUsageOther': 'Altro',
	'autoBinActionText': 'Raggruppa automatico',
	'filterAutobinActionText': 'Filtra bin',
	'memberCalculationActionText': 'Calcolo membro',
	'toolbarActionCalculation': 'Crea calcolo',
	'toolbarActionEditCalculation': 'Modifica calcolo',
	'topBottomRankLabel': 'Classifica (%{label})',
	'toolbarDeleteFilterActionText': 'Rimuovi filtro',
	'toolbarActionTopKeyDrivers': 'Mostra driver',
	'toolbarActionCustomGroup': 'Gruppo personalizzato',
	'canNotCreateCustomGroup': 'Impossibile creare questo gruppo personalizzato.',
	'aria_label_datatable': 'Tabella dati',
	'summaryCaption': 'Riepilogo',
	'MeasuresCaption': 'Misure',
	'MeasuresGroupCaption': 'Gruppo misure (%{count})',
	'ValuesCaption': 'Valori',
	'turnInsightsOn': 'Attiva insights',
	'turnInsightsOff': 'Disattiva insights',
	'decisionRules': 'Regole',
	'decisionTree': 'Diagramma struttura ad albero',
	'decisionSunburst': 'Grafico radiale struttura ad albero',
	'switchToDecisionRules': 'Passa a regole decisione',
	'switchToDecisionTree': 'Passa a struttura decisione',
	'data_group_less_then': 'meno di %{rangeTo}',
	'data_group_to': '%{rangeFrom} in < %{rangeTo}',
	'data_group_and_above': '%{rangeFrom} e successivo',
	'nullValueContent': '(nessun valore)',
	'sum': 'Somma',
	'count': 'Conteggio',
	'countdistinct': 'Conteggio distinti',
	'avg': 'Medio',
	'min': 'Minimo',
	'max': 'Massimo',
	'automatic': 'Personalizzato',
	'variance': 'Varianza',
	'stddev': 'Deviazione standard',
	'median': 'Mediana',
	'calculated': 'Calcolato',
	'none': 'Nessuna',
	'measureLabel': '%{measureName}',
	'multiMeasureLabel': '%{measureName} (%{aggregate})',
	'aggregatedColumnLabel': '%{column} (%{aggregationTypeLabel})',
	'promptTitle': 'Valori prompt',
	'inputLabelPrompt': 'Valore',
	'inputPlaceholderPrompt': 'Immetti valore',
	'inputInvalidText': 'Input non valido per %{dataType} type',
	'unSupportedPrompt': 'Prompt non supportato',
	'missingDataSource': 'Impossibile trovare l\'origine dati giusta.',
	'unSupportedPromptType': 'Lo scenario di prompt non è attualmente supportato.',
	'preAggregateLabel': 'Applica i valori di prompt dell\'origine dati',
	'postAggregateLabel': 'Applica i valori di prompt nel report',
	'preAggregateText': 'L\'intervallo utilizza i valori nell\'origine dati, non i valori visualizzati nel dashboard.',
	'defaultAggregation_count': 'Conteggio',
	'defaultAggregation_countdistinct': 'Conteggio distinti',
	'defaultAggregation_max': 'Massimo',
	'defaultAggregation_min': 'Minimo',
	'defaultAggregation_avg': 'Medio',
	'defaultAggregation_sum': 'Somma',
	'defaultAggregation_auto': 'Auto (%{aggregationType})',
	'keydriver_average': 'Media generale',
	'keydriver_up_down': 'I gruppi evidenziati con medie elevate o basse hanno maggiore impatto sull\'obiettivo. I gruppi con medie insolitamente alte o basse hanno l\'impatto maggiore.',
	'keydriver_different': 'I gruppi evidenziati hanno distribuzioni che differiscono significativamente dalla distribuzione generale. Questi gruppi hanno maggiore impatto sull\'obiettivo.',
	'topOperator': 'In alto',
	'bottomOperator': 'In basso',
	'topBottomFact': '%{operator} %{value}%{percent} per %{columnLabel}',
	'topBottomDimension': '%{operator} %{value}%{percent}',
	'deleteTopBottomCount': 'Elimina conteggio dei primi elementi o degli ultimi elementi',
	'deleteTopBottomPercent': 'Elimina primi elementi o ultimi %',
	'topBottomTitle': 'Solo questo oggetto',
	'deleteTopBottom': 'Elimina conteggio dei primi elementi o degli ultimi elementi',
	'editTopBottom': 'Modifica conteggio dei primi elementi o degli ultimi elementi',
	'editTopBottomCount': 'Modifica conteggio dei primi elementi o degli ultimi elementi',
	'editTopBottomPercent': 'Modifica primi elementi o ultimi %',
	'ariaDeleteTopBottomCountLabel': 'Premere il tasto ELIMINA per eliminare il conteggio dei primi elementi o degli ultimi elementi.',
	'ariaDeleteTopBottomPercentLabel': 'Premere il tasto ELIMINA per eliminare i primi elementi o gli ultimi',
	'ariaEditTopBottomCountLabel': 'Premere INVIO per modificare il conteggio dei primi elementi o degli ultimi elementi.',
	'ariaEditTopBottomPercentLabel': 'Premere il tasto INVIO per modificare i primi elementi o gli ultimi %.',
	'ariaDeleteDrillStateLabel': 'Premere INVIO per modificare il conteggio dei primi elementi o degli ultimi elementi.',
	'drillUpStateTitle': 'Drill up',
	'drillDownStateTitle': 'Drill down',
	'ariaEditTopBottomLabel': 'Premere INVIO per modificare il conteggio dei primi elementi o degli ultimi elementi.',
	'ariaDeleteTopBottomLabel': 'Premere il tasto ELIMINA per eliminare il conteggio dei primi elementi o degli ultimi elementi.',
	'allKeyDriversLabel': 'Auto (tutti i driver)',
	'filter_drag_and_drop_single_dock': 'Trascinare e rilasciare i dati in questo punto per filtrare.',
	'filter_drag_and_drop_all_tabs': 'Trascinare e rilasciare i dati in questo punto per filtrare tutte le schede.',
	'filter_drag_and_drop_current_tab': 'Trascinare e rilasciare i dati in questo punto per filtrare questa scheda.',
	'filter_empty_consume_mode': 'Non sono stati applicati filtri.',
	'filterClearAllItems': 'Annulla tutti i filtri',
	'filterDeleteAllItems': 'Elimina tutti i filtri',
	'filterDockChevronLeft': 'Scorrere i dati',
	'filterDockChevronRight': 'Scorrere i dati',
	'filterIconLabel_Single': 'Filtri',
	'filterIconLabel_Global': 'Tutte le schede',
	'filterIconLabel_Tab': 'Questa scheda',
	'filterIconTooltip_Single': 'Filtri',
	'filterIconTooltip_Global': 'Filtri per tutte le schede',
	'filterIconTooltip_Tab': 'Filtri per questa scheda',
	'filterDropZoneTooltip_Single': 'Zona di rilascio filtro',
	'filterDropZoneTooltip_Global': 'Zona di rilascio filtro per tutte le schede',
	'filterDropZoneTooltip_Tab': 'Zona di rilascio filtro per questa scheda',
	'filterOverflowMenu': 'Altro',
	'expand': 'Espandi',
	'collapse': 'Comprimi',
	'filterDockItemNameAriaLabel': 'Premere Invio per avviare la finestra di dialogo del filtro e definire il filtro.',
	'filterItemCanvasMove': 'Aggiungi ad area di lavoro',
	'filterItemDelete': 'Elimina filtro',
	'filterInvertRange': 'tutto tranne: %{from}-%{to}',
	'filterRange': '%{from}-%{to}',
	'filter_date_after_except': 'Non dopo %{from}',
	'filter_date_after': 'Dopo %{from}',
	'filter_date_before_except': 'Non prima %{to}',
	'filter_date_before': 'Prima %{to}',
	'filter_date_between_except': 'Non compreso tra %{from}-%{to}',
	'filter_date_between': 'Compreso tra %{from}-%{to}',
	'filterValueSeparator': ',',
	'filterAll': 'Tutte',
	'filter': 'Filtro',
	'filterExcept': 'tranne %{values}',
	'filterDockToolbarButtonLabel': 'Dock filtro',
	'navigateTitle': 'Passa a',
	'navigateSelectColumn': 'Selezionare una colonna',
	'navigateSelectPath': 'Seleziona un percorso di navigazione',
	'current_nav_group': 'Il gruppo di navigazione corrente è %{navigation_group_name}',
	'next': 'Avanti',
	'previous': 'Indietro',
	'multiselectMsg': '%{count} selezionato',
	'errMsgFilterItemMissingTitle': 'Il valore del filtro  %{itemName} non può essere caricato perché questi valori non sono disponibili con questo dataset',
	'errMsgFilterItemGenericTitle': 'Impossibile caricare i valori filtro',
	'textFilterItemsNotFound': 'Nessun elemento disponibile.',
	'nullValueLabel': '(vuoto)',
	'filterConditionLabel': 'Condizione filtro',
	'filter_includesAll': 'Include tutto',
	'filter_allMembersOfSet': 'Tutti i membri della serie',
	'modelFilter': 'Filtro',
	'filtersTitle': 'Proprietà filtro',
	'search': 'Ricerca',
	'clearTextFilterValue': 'Annulla',
	'invertFilterSelection': 'Inverti',
	'modellingLoading': 'Caricamento in corso...',
	'searchAll': 'Trova tutte le colonne',
	'toolbarActionPossibleKeyDrivers': 'Modifica ambito',
	'toolbarActionPossibleKeyDriversSubTitle': 'Trascinare da sinistra gli elementi che devono essere considerati nel grafico di analisi driver',
	'toolbarActionSort': 'Ordinamento',
	'toolbarActionSortAscending': 'Crescente',
	'toolbarActionSortDescending': 'Discendente',
	'toolbarActionSortAuto': 'Auto (%{sortOrder})',
	'toolbarActionSortCustom': 'Personalizzato',
	'toolbarActionFormat': 'Formatta dati',
	'toolbarActionFormatText': 'Formata i dati (testo)',
	'toolbarActionFormatAbbreviation': 'Abbrevia',
	'toolbarActionFormatNone': 'Automatico',
	'toolbarActionFilter': 'Filtro',
	'toolbarActionTopBottom': 'Primi elementi o ultimi elementi',
	'toolbarActionRmvShape': 'Rimuovi forma',
	'toolbarActionToggleShapeDrop': 'Forma infografico',
	'toolbarActionToggleShapeDropTitle': 'Crea un infografico',
	'toolbarActionToggleShapeDropText': 'Trascinare la forma in questo campo per creare un infografico.',
	'toolbarActionAggregationType': 'Riepiloga',
	'toolbarDeleteActionText': 'Rimuovi colonna',
	'toolbarTextActionText': 'Testo di stile',
	'toolbarActionFilterLocalKeepSelected': 'Conserva',
	'toolbarActionFilterLocalExcludeSelected': 'Escludi',
	'toolbarActionFilterAllKeepSelected': 'Filtro',
	'toolbarActionSimpleCalculation': 'Calcoli semplici',
	'toolbarActionDrillBack': 'Indietro',
	'toolbarActionDrillUp': 'Drill up',
	'toolbarActionDrillDown': 'Drill down',
	'toolbarActionJumpTo': 'Drill through',
	'toolbarActionNavigate': 'Naviga',
	'toolbarActionCreateFilterGroup': 'Crea nuova connessione',
	'toolbarActionDisconnectFilterGroup': 'Interrompi tutti i collegamenti',
	'toolbarActionLinkFilterGroup': 'Aggiungi ad una connessione esistente',
	'toolbarActionLassoSelect': 'Seleziona strumento',
	'toolbarActionRefreshDeveloperWidget': 'Aggiorna',
	'textFontFamilySubClassHairline': 'Sottile',
	'textFontFamilySubClassThin': 'Sottile',
	'textFontFamilySubClassThinItalic': 'Corsivo sottile',
	'textFontFamilySubClassExtraLight': 'Chiarissimo',
	'textFontFamilySubClassExtraLightItalic': 'Corsivo chiarissimo',
	'textFontFamilySubClassLight': 'Chiaro',
	'textFontFamilySubClassLightItalic': 'Corsivo chiaro',
	'textFontFamilySubClassRegular': 'Regolare',
	'textFontFamilySubClassRegularItalic': 'Corsivo regolare',
	'textFontFamilySubClassItalic': 'Corsivo',
	'textFontFamilySubClassMedium': 'Medio',
	'textFontFamilySubClassMediumItalic': 'Corsivo medio',
	'textFontFamilySubClassHeavy': 'Pesante',
	'textFontFamilySubClassHeavyItalic': 'Corsivo pesante',
	'textFontFamilySubClassDemiBold': 'Mezzo grassetto',
	'textFontFamilySubClassDemiBoldItalic': 'Corsivo mezzo grassetto',
	'textFontFamilySubClassBold': 'Grassetto',
	'textFontFamilySubClassBoldItalic': 'Corsivo grassetto',
	'textFontFamilySubClassExtraBold': 'Grassetto scuro',
	'textFontFamilySubClassExtraBoldItalic': 'Corsivo scuro',
	'textFontFamilySubClassBlack': 'Nero',
	'textFontFamilySubClassBlackItalic': 'Corsivo nero',
	'textFontFamilySubClassStencil': 'Stencil',
	'dlg_ascending': 'ascendente',
	'dlg_descending': 'discendente',
	'dlg_custom': 'personalizzato',
	'dlg_none': 'nessuno',
	'dlg_hierarchy': 'gerarchia',
	'dlg_namedSet': 'insieme denominato',
	'dlg_rank': 'classifica',
	'visualizationLabel': 'Visualizzazione',
	'chartLabel': '%{chartName} grafico',
	'dataWidgetDescription': '%{widgetLabel}: %{columnNames}',
	'f12KeyDescription': 'Premere F12 per navigare all\'interno del widget',
	'f10KeyDescription': 'Premere F10 per avviare la vista attiva del widget',
	'playButtonLabel': 'Riproduci',
	'dataPlayerValueListLabel': 'Valori Data player',
	'localFilterTitle': 'Solo questo oggetto',
	'globalFilterTitle': 'Tutti gli oggetti',
	'deleteFilter': 'Elimina filtro',
	'editFilter': 'Modifica filtro',
	'ariaEditFilterLabel': 'Premere il tasto INVIO per modificare il filtro.',
	'ariaDeleteFilterLabel': 'Premere il tasto ELIMINA per eliminare il filtro.',
	'measureFilterBetween': 'Compreso tra %{lowerBound} e %{upperBound}',
	'measureFilterNotBetween': 'Non compreso tra %{lowerBound} e %{upperBound}',
	'dimFilterIn': 'Include: %{in}',
	'dimFilterNotIn': 'Esclude: %{out}',
	'gtFilter': 'Dopo %{lowerBound}',
	'ltFilter': 'Prima %{upperBound}',
	'ariaEditPrompt': 'Premere il tasto INVIO per modificare il valore di prompt',
	'dataPointFilterTitle': 'Punti dati',
	'dataPointFilterIncludeSummary': 'Inclusi %{valueCount} punti di dati',
	'dataPointFilterExcludeSummary': 'Esclusi %{valueCount} i punti dati',
	'widgetFiltersLabel': 'Filtri del widget',
	'coachMarkTitleSpiralTarget': 'Modifica ambito',
	'coachMarkContentSpiralTarget': 'Da qui è possibile accedere e modificare la selezione del driver per la propria destinazione.',
	'srILVTreeLabel': 'Elenco',
	'geomapUnrecognizedLocations': 'Ubicazioni non riconosciute',
	'geomapAmbiguousLocations': 'Regioni ambigue:',
	'visualizationNotifications': 'Notifiche di visualizzazione:',
	'dataNotifications': 'Notifiche di dati:',
	'autobinSuggestion': 'Attiva raggruppamento automatico',
	'LIVE_empty_visualization_hint_title': 'Creazione della visualizzazione',
	'LIVE_empty_visualization_hint_description': 'Trascinare i dati qui o sui campi.',
	'LIVE_slots_required_field_description': '%{asterisk} Indica un campo obbligatorio',
	'LIVE_slots_drag_and_drop_description': 'Trascinare e rilasciare i dati nei campi sopra per costruire e filtrare la visualizzazione.',
	'dwErrorLoadingAvailableVisualizations': 'Impossibile caricare le definizioni di visualizzazione disponibili',
	'moreDataIndicator': 'I dati sono stati ritagliati in %{threshold} elementi. Applicare un filtro per mostrarne di meno.',
	'nonCtxTopBottomInvalid': 'La definizione di una regola superiore o inferiore senza un contesto non è supportata per le tabelle incrociate. È stato rimosso da questa vista di tabella incrociata.  Ridefinire la regola su una o più categorie nel contesto di %{columnName}.',
	'dwErrorLoadingVisualizationNotFound': 'Non possiamo caricare l\'oggetto, perché manca una definizione di visualizzazione.',
	'dwErrorLoadingVisualizationListNotFound': 'Impossibile caricare la visualizzazione.',
	'dwErrorRunningQuery': 'Non è possibile richiamare i dati dal dataset %{datasetName}.',
	'dwErrorGeoData': 'Si stanno verificando problemi durante la visualizzazione dei dati geografici nella mappa. Scegliere un altro tipo di visualizzazione.',
	'dwPromptSignonCancelWarning': 'I dati di questa visualizzazione non sono disponibili. Fornire le credenziali corrette.',
	'dwErrorMissingDataset': 'Non è possibile caricare la visualizzazione, perché il suo dataset associato "%{datasetName}" non è disponibile.',
	'dwErrorRenderingVisualization': 'Impossibile caricare questa visualizzazione.',
	'dwErrorVisualizationTooSmall': 'La visualizzazione è troppo piccola per visualizzare i dati che contiene. Ingrandire la visualizzazione o limitare i dati che contiene.',
	'errorSourceNotFound': 'Non è possibile caricare la visualizzazione, perché la sua origine associata "%{sourceName}" non è disponibile.',
	'errorActionNotSupported': 'Questa azione non è supportata per l\'origine dati "%{sourceName}".',
	'errorMeasureNotSupportedOnMultiEdges': 'La visualizzazione dispone di misure su più bordi, che non sono più supportate. Posizionare le misure su un solo bordo.',
	'errorExceedAllowableValue': 'Il numero stimato di celle supera il valore ammissibile di 100000. Applicare filtri per gli insiemi progettati per ridurre il numero di celle.',
	'propScaleLabel': 'Quantità di icone',
	'propScaleDescription': 'Selezionare le quantità di icone',
	'propScaleFew': 'Basso',
	'propScaleDefault': 'Impostazione predefinita',
	'propScaleMany': 'Alto',
	'lastRefresh': 'Ultimo aggiornamento: %{timeInterval} fa',
	'widgetTimer': 'Timer del widget',
	'datasetItemsUnavailable': 'Alcuni elementi del dataset utilizzati in questa visualizzazione non sono disponibili.',
	'datasetItemUnavailable': 'Questo elemento del dataset non è disponibile',
	'retry': 'Riprova',
	'widgetConditionalFormatLabel': 'Attiva/disattiva i controlli di formato condizionali',
	'widgetConditionalFormatTitle': 'Modifica colore di formattazione condizionale',
	'crosstabName': 'Tabella incrociata',
	'WidgetLabelWithDescripion': '%{label}. %{description}',
	'value_is_not_available': 'N/D',
	'summaryLabel': '%{label} con valore %{value}',
	'infographicLabel': '%{label} con valore %{value}',
	'warning': 'Avviso',
	'swapRowsAndColumns': 'Inverti righe e colonne',
	'hideSummariesLabel': 'Nascondi riepiloghi',
	'showSummariesLabel': 'Mostra riepiloghi',
	'hideRowColumn': 'Nascondi',
	'showAllRowColumn': 'Mostra tutto',
	'dataAssetPropertiesLabel': 'Proprietà di visualizzazione',
	'evAdd': 'Aggiungi una colonna',
	'evCollapse': 'Comprimi',
	'evColumns': 'Colonne',
	'evLocalFilters': 'Filtri locali',
	'evExpand': 'Espandi',
	'evFilterTooltip': 'Filtro',
	'missingColumn': 'Mancante: %{columnLabel}',
	'missingFiltering': 'Filtri mancanti sulle colonne:',
	'missingDataItem': 'L\'elemento dati di riferimento "%{dataItemId}" non è stato trovato nel widget.',
	'heatByLabel': 'Calore per',
	'toolbarChangeVisualization': 'Visualizzazione modifica',
	'modellingRelatedTablesNoneFound': 'Nessuna tabella correlata trovata',
	'processing': 'Elaborazione in corso...',
	'errorCellWarning': 'Impossibile calcolare alcuni valori di riepilogo.',
	'aggregateTypeToggler': 'Mostra tipo di aggregazione',
	'maxColumnsExceeded': 'Numero massimo di colonne superato. %{columns} eliminato.',
	'unboundColumns': 'Impossibile utilizzare le seguenti colonne:%{columns}.',
	'unboundColumn': 'Impossibile utilizzare la seguente colonna:%{columns}.',
	'recommendRequestFailed': 'Richiesta di consiglio non riuscita. Rivolgersi all\'amministratore.',
	'visualizationDoesNotSupportOLAP': 'Impossibile creare questa visualizzazione che si basa su un\'origine dati OLAP. Utilizzare un\'altra origine dati supportata.',
	'showDataBehindVizLabel': 'Mostra dati',
	'showDataBehindVizNotSupportedLabel': 'L\'opzione Mostra dati non è supportata per questo tipo di visualizzazione',
	'exploreData': 'Esplora ...',
	'newExplore': 'Nuova esplorazione',
	'thumbnails_error_fetching': 'Errore durante il richiamo delle anteprime',
	'loadedThumbnailImage': 'Caricata immagine in miniatura della visualizzazione %{visType}',
	'autobinAxisLabel': 'gruppi',
	'recommended_visualizations': 'Visualizzazioni consigliate',
	'all_visualizations': 'Tutte le visualizzazioni',
	'edit': 'Modifica',
	'selectTargetDialogTitle': 'Seleziona una destinazione drill-through',
	'noTargetInCM': 'Impossibile trovare la destinazione del drill-through',
	'errorDrillDefinition': 'Qualcosa non era corretto durante l\'aggiunta o la modifica della definizione drill-through.',
	'errorDrillToTarget': 'Si è verificato un errore durante il drill a "%{targetName}"',
	'drillThroughMappingViewLabel': 'Assegna le colonne dal dashboard per i prompt del report di destinazione',
	'drillthroughScopeRadioLabel': 'Applicare questa definizione a:',
	'drillthroughScopeRadioOptionVisualization': 'Solo questa visualizzazione',
	'drillthroughScopeRadioOptionConnection': 'Visualizzazioni nella stessa connessione che utilizzano la stessa origine dati',
	'drillthroughScopeRadioOptionDashboard': 'Qualsiasi visualizzazione su %{perspective} che utilizza la stessa origine dati',
	'drillThroughParametersColumnTitle': '"%{targetName}" prompt:',
	'drillThroughMetadataColumnTitle': '"%{boardName}" colonne dati:',
	'drillThroughDefinitionNoParameter': 'La destinazione di drill-through non dispone di prompt.',
	'drillThroughDefinitionErrorQueryingReport': 'Correggere il problema con il report di destinazione e quindi ritentare la creazione della definizione drill-through.',
	'drillThroughDefinitionErrorDlgTitle': 'Qualcosa non era corretto',
	'dlg_back': 'Torna indietro',
	'dlg_close': 'Chiudi',
	'dlg_ok': 'OK',
	'dlg_cancel': 'Annulla',
	'dlg_apply': 'Applica',
	'dlg_create': 'Crea',
	'dlg_done': 'Fine',
	'drillthrough_unsaveMsg': 'Continuare senza salvare "%{name}"?',
	'drillthrough_jumpTo': 'Definizione drill-through:%{name}',
	'drillthrough_jumpToLabel': 'Drill through',
	'drillthrough_manage': 'Gestione in corso...',
	'drillthrough_addNewTarget': 'Aggiungi una nuova definizione drill-through',
	'drillthrough_manageJumpPaths': 'Gestisci definizioni drill-through',
	'drillthrough_manageJumpPaths_edit': 'Modifica "%{name}"',
	'drillthrough_manageJumpPaths_delete': 'Elimina "%{name}"',
	'drillthrough_manageAddAnotherTarget': 'Aggiungi un\'altra definizione drill-through',
	'drillthrough_manageConfirmeDeleteDrillTargetTitle': 'Conferma eliminazione',
	'drillthrough_manageConfirmeDeleteDrillTarget': 'Si è sicuri di voler eliminare il drill-through "%{name}"?',
	'drillthrough_definitionDuplicateDrillTargetErrorTitle': 'Nome drill-through duplicato',
	'drillthrough_definitionMessage': 'Drill-through "%{name}" esiste già. Fornire un differente nome',
	'drillthrough_jumpToTarget_notFound': 'Destinazione non trovata per il drill-through "%{name}"',
	'drillThroughDefinitionNoParameterSubTitle': 'Nessun contesto verrà passato al report di destinazione.',
	'drillthrough_titleLabel': 'Nome',
	'drillthrough_create_dialogTitle': 'Crea definizione di drill-through',
	'drillthrough_edit_dialogTitle': 'Modifica definizione di drill-through',
	'drillthrough_subTitle': 'Il contesto della visualizzazione nella propria origine viene utilizzato per filtrare la destinazione %{perspective}.',
	'drillthrough_selectColumn': 'Selezionare una colonna',
	'noPrompt': 'Nessun prompt',
	'promptDialog': '%{promptType} Finestra di dialogo prompt',
	'formatAutoDescription': 'Specifica automaticamente il formato ereditato dall\'origine dati o dalla visualizzazione.',
	'formatDefaultDescription': 'Specifica predefinita del formato ereditato dal sistema',
	'createCustomGroupAction': 'Crea gruppo di dati',
	'removeCustomGroupAction': 'Rimuovi gruppo di dati',
	'editCustomGroupAction': 'Modifica gruppo di dati',
	'renameCustomGroupAction': 'Rinomina gruppo di dati',
	'createCustomGroupErrorToast': 'Impossibile creare un gruppo di dati',
	'removeCustomGroupErrorToast': 'Impossibile rimuovere un gruppo di dati',
	'editCustomGroupErrorToast': 'Impossibile modificare un gruppo di dati',
	'renameCustomGroupErrorToast': 'Impossibile rinominare un gruppo di dati',
	'customGroupLabel': 'Crea gruppo di dati',
	'ungroupCustomGroupLabel': 'Annulla raggruppamento',
	'renameCustomGroupLabel': 'Ridenomina',
	'createCustomGroupLabel': 'Crea',
	'customGroupingLabel': '%{columnLabel} (Gruppo)',
	'createCustomSort': 'Crea ordinamento personalizzato',
	'createCustomSortTitle': '%{name}',
	'createCustomSortDesc': 'Selezionare gli articoli disponibili, quindi riordinarli per creare un ordinamento personalizzato.',
	'availableItems': 'Elementi disponibili',
	'selectAll': 'Seleziona tutto',
	'customSortOrder': 'Ordinamento personalizzato',
	'selectAvailableItemsDesc': 'Seleziona gli articoli disponibili quindi riordina qui.',
	'moveToTop': 'Sposta in alto',
	'clear': 'Annulla',
	'sortRemainingItemsBy': 'Ordina gli elementi rimanenti per',
	'removeAll': 'Rimuovi tutto',
	'resetTooltip': 'Tutti gli elementi verranno rimossi dall\'elenco %{customSortOrder}. E il %{sortRemainingItemsBy} a discesa tornerà al valore predefinito.',
	'manyItemsWarning': 'La selezione di molti articoli potrebbe influire sul rendimento della tua dashboard.',
	'manyItemsSelected': 'Sono stati selezionati più di %{maxItems} elementi, questo potrebbe influire sul rendimento del dashboard.',
	'somethingWentWrong': 'Uh oh. Qualcosa non va.',
	'tryAgain': 'Ritenta',
	'customSortLabel': 'Ordinamento personalizzato',
	'applyError': 'Impossibile applicare%{action}.',
	'searchReturnedNoResults': 'La ricerca non ha restituito alcun risultato.',
	'extVisSystem': 'Sistema',
	'extVisCustom': 'Personalizzato',
	'customVisTestVisualization': 'Visualizzazione di test',
	'extVisCustomVisPreview': 'anteprima',
	'extVisCustomPreviewWidgets': 'Widget sviluppatori',
	'extVisCustomVVisualization': 'Visualizzazione',
	'extVisCustomVisuals': 'Visualizzazioni personalizzate',
	'noPermissionToManage': 'Non si dispone dell\'autorizzazione per gestire le visualizzazioni personalizzate.',
	'extVisCustomUpdate': 'Aggiorna',
	'extVisCustomDelete': 'Elimina',
	'extVisNoCustomVisuals': 'Nessuna visualizzazione personalizzata',
	'extVisNoCustomVisualsMsg': 'Nell\'organizzazione non sono attualmente presenti visualizzazioni personalizzate',
	'extVisAddCustomVisual': 'Aggiungi una visualizzazione personalizzata',
	'extVisNoCustomVisualsAdminMsg': 'Attualmente non esistono visualizzazioni personalizzate. Aggiungerne una per iniziare',
	'extVisNoSDKConnection': 'Non è stata creata nessuna connessione al file locale',
	'extVisNoSDKPreviewMsg': 'Per eseguire l\'anteprima delle visualizzazioni, stabilire una connessione.',
	'extVisMore': 'Altro',
	'extVisDeleteDialogTitle': 'Elimina visualizzazione personalizzata',
	'extVisDeleteDialogBody': 'Si è sicuri di voler eliminare questa visualizzazione personalizzata? Questa visualizzazione potrebbe essere utilizzata da altri dashboard e report.',
	'extVisDeleteConfirmation': 'La visualizzazione personalizzata è stata eliminata.',
	'extVisDeleteError': 'Impossibile eliminare la visualizzazione personalizzata %{msg}',
	'extVisCloseToast': 'Chiudi ora',
	'extVisAdd': 'La visualizzazione personalizzata è stata aggiunta correttamente.',
	'extVisAddError': 'Impossibile aggiungere la visualizzazione personalizzata. %{msg}',
	'extVisUpdate': 'La visualizzazione personalizzata è stata aggiornata correttamente',
	'extVisUpdateError': 'Impossibile aggiornare la visualizzazione aggiornata %{msg}',
	'extVisAddProgress': 'Importazione di %{name}',
	'extVisUpdateProgress': 'Aggiornamento di %{name}',
	'extPermissionTitle': 'Accesso limitato o visualizzazione personalizzata eliminata',
	'extPermissionBody': 'Impossibile visualizzare  questa visualizzazione personalizzata perché è stata eliminata o ha un accesso limitato.',
	'customVizSaveWarning': 'Impossibile salvare le visualizzazioni personalizzate. Non sono stati importate.',
	'schematicTestCaption': 'Schema test',
	'schematicServiceRequestError': 'Errore servizio schema',
	'extVisPreviewMessage': 'Questa è un\'anteprima. La visualizzazione non è stata ancora aggiunta al prodotto.',
	'kpiTargetWithDistance': '%{value} (%{distance})',
	'kpiDistanceUndefined': 'Non definito',
	'kpiDefaultTargetLabel': 'Destinazione',
	'kpiNonNumericTarget': 'Il valore di destinazione deve essere un numero.',
	'kpiManualTargetSlotFilled': 'Valore applicato nel campo',
	'kpiAutoValueSize': 'Automatico',
	'kpiUnableDrawSparklineLabel': 'Impossibile disegnare una sparkline',
	'kpiUnableDrawSparklineInfo': 'Una sparkline richiede un minimo di due punti nel tempo. Modificare i dati o regolare i filtri per vedere la sparkline.',
	'conditionalFormattingTextColor': 'Colore testo',
	'suppression': 'Soppressione',
	'suppressNone': 'Nessuna',
	'suppressRowsAndColumns': 'Righe e colonne',
	'suppressRows': 'Righe',
	'suppressColumns': 'Colonne',
	'enableSuppression': 'Abilita soppressione',
	'disableSuppression': 'Disabilita soppressione',
	'loadVisDefinitionError': 'Impossibile caricare la definizione per la visualizzazione di %{id}',
	'emptyVisualization': 'Svuota visualizzazione',
	'expandCollapse': 'Espandi & riduci al minimo',
	'expandBtnLabel': 'Espandi',
	'collapseBtnLabel': 'Comprimi',
	'prop_sizeInputNonNumericValue': 'Il valore deve essere un numero.',
	'prop_sizeValueShouldBeHigher': 'Il valore deve essere maggiore di %{value}.',
	'fontPropLabel': 'Famiglia di caratteri',
	'fontSizePropLabel': 'Dimensione carattere',
	'sectionItemAxisTitle': 'Titolo asse elemento',
	'sectionItemAxisLabel': 'Etichetta asse elemento',
	'sectionValueAxisTitle': 'Titolo asse valore',
	'sectionValueAxisLabel': 'Etichetta asse valore',
	'styletext-widget.legend': 'Legenda',
	'styletext-itemAxis.ticks.labels': 'Etichette assi',
	'styletext-valueAxis.title': 'Titolo assi',
	'styletext-itemAxis.title': 'Titoli assi',
	'styletext-labels': 'Etichette dati',
	'styletext-valueAxis.line.title': 'Titoli linea',
	'styletext-cellValue': 'Valori',
	'styletext-values': 'Valori',
	'styletext-rowHeading': 'Intestazioni riga',
	'styletext-columnHeading': 'Intestazioni colonna',
	'fontFamily': 'cognome',
	'fontSize': 'dimensione',
	'visExportFileName': 'Visualizzazione',
	'ds-missingDataSet': 'Impossibile trovare dataset. Assicurarsi che il dataset venga creato correttamente.',
	'ds-missingDashboardId': 'Salvare dashboard prima di creare il dataset.',
	'ds-unsupportedDataSourceType': 'Il tipo di origine dati %{type} non è supportato.',
	'dataCache': 'Cache dati',
	'dataCache_on': 'Attivo',
	'dataCache_off': 'Nessuna cache',
	'dataCache_auto': 'Automatico',
	'queryOptimization': 'Ottimizzazione della query'
});
